import noop from 'hs-lodash/noop';
export const getTrackingHandler = map => {
  return key => {
    return map.has(key) ? map.get(key) : noop;
  };
};